<template lang="pug">
  div
    .text-md.font-semibold.neutral700--text Redeem offer
    .text-sm.mb-4 Select which offer you would like to redeem.
    template(v-if="coupons.isFetching")
      v-skeleton-loader(type="list-item-two-line@3")
    template(v-else)
      template(v-if="coupons.data.length === 0")
        v-card.pa-4(outlined)
          .text-xs.text-center.neutral500--text No offer available
      template(v-else)
        redeem-offer-list-item(:offer-items="coupons.data" @selected="handleSelectedOffer")
    .d-flex.mt-5(v-if="coupons.totalCount > coupons.pageSize")
      v-spacer
      yc-pagination-custom(v-model="coupons.page" :parentPageSize.sync="coupons.pageSize" :count="coupons.totalCount" attach menu-top @input="pageChanged")
    .dialogs
      apply-offer(v-if="applyOffer.open" :open.sync="applyOffer.open" :offer="applyOffer.data" :profile="profile" @close="handleCloseApplyOffer" @backToHomepage="$emit('backToHomepage')" @applied="$emit('applied')")
</template>

<script>
import RedeemOfferListItem from "@/components/marketing/merchantapp/offer/RedeemOfferListItem.vue";
import ApplyOffer from "@/components/marketing/merchantapp/bottomdialogs/ApplyOffer.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    ApplyOffer,
    RedeemOfferListItem
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      coupons: {
        isFetching: true,
        data: [],
        totalCount: 0,
        pageSize: 5,
        page: 1,
      },
      applyOffer: {
        data: null,
        open: false,
      }
    }
  },
  mounted() {
    this.fetchOffers()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    pageChanged() {
      this.fetchOffers()
    },
    async fetchOffers() {
      const url = `/marketing/${this.company.slug}/coupons`
      const params = {
        loyalty_member: this.profile.id,
        ordering: 'expired_at',
        page_size: this.coupons.pageSize,
        page: this.coupons.page,
      }
      try {
        this.coupons.isFetching = true
        const {data} = await this.$axios.get(url, {params})
        this.coupons.data = data.results
        this.coupons.totalCount = data.count
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.coupons.isFetching = false
      }
    },
    handleSelectedOffer(item) {
      this.applyOffer.data = item
      this.applyOffer.open = true
    },
    handleCloseApplyOffer() {
      this.applyOffer.data = null
    },
  },
}
</script>

<style scoped>

</style>